var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailFast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0.5H9C7.9 0.5 7 1.4 7 2.5V11.5C7 12.61 7.9 13.5 9 13.5H22C23.11 13.5 24 12.61 24 11.5V2.5C24 1.4 23.11 0.5 22 0.5ZM22 4.17L15.5 7.5L9 4.17V2.5L15.5 5.81L22 2.5V4.17ZM5 11.5C5 11.67 5.03 11.83 5.05 12H1C0.448 12 0 11.55 0 11C0 10.45 0.448 10 1 10H5V11.5ZM3 2H5.05C5.03 2.17 5 2.33 5 2.5V4H3C2.45 4 2 3.55 2 3C2 2.45 2.45 2 3 2ZM1 7C1 6.45 1.45 6 2 6H5V8H2C1.45 8 1 7.55 1 7Z",
    fill: "#7BB8F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFast);
export default __webpack_public_path__ + "static/media/email-fast.c6f6b474d056c30d7c1478eb0511e286.svg";
export { ForwardRef as ReactComponent };